import React from 'react';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getFilteredRowModel,
	getSortedRowModel,
	SortingState,
	useReactTable,
	Table as __Table,
} from '@tanstack/react-table';
import { Table as BTable } from 'react-bootstrap';
import { EducationDataEntry } from './EducationOverview';
import TableBody from '../../Components/TableBody';
import TableHeader from '../../Components/TableHeader';

type Props = {
	data: EducationDataEntry[];
	columns: AccessorKeyColumnDef<EducationDataEntry, unknown>[];
};
const Table = ({ data, columns }: Props) => {
	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'start',
			desc: true,
		},
	]);

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
		onSortingChange: setSorting,
		enableGlobalFilter: true,
		state: {
			sorting,
		},
	});
	return (
		<BTable responsive hover size={'l'}>
			<TableHeader table={table as __Table<unknown>} />
			<TableBody table={table as __Table<unknown>} />
		</BTable>
	);
};
export default Table;
